<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.99 11 3 15l3.99 4v-3H14v-2H6.99v-3ZM21 9l-3.99-4v3H10v2h7.01v3L21 9Z"
    />
  </svg>
</template>
